export default __webpack_public_path__ + "static/media/list.365e7fec.svg";